export const modules =
{
    SaleManagement: 'Sale.Management'
}

export const statuses =
{
    Success: 'Success',
    Warning: 'Warning',
    Failed: 'Failed',
}

export const actions =
{
    sale: {
        action: 'sale.action',
        publish: 'sale.publish',
        receive: 'sale.receive',
        cancel: 'sale.cancel',
        refund: 'sale.refund',
        paymentRequested: 'sale.payment.requested',
        paymentReceipt: 'sale.payment.receipt',
        paymentRefund: 'sale.payment.refund',
        paymentFailed: 'sale.payment.failed',
    },
}
